import { defineComponent as _defineComponent } from 'vue'
import {onBeforeMount, ref} from "vue";
import {object} from "yup";
import * as Yup from "yup";
import Password from "primevue/password";
import {pattern} from "@/utils/passwordPattern";
import {Field, Form} from "vee-validate";



export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordStep3',
  props: {
  newPassword: {
    type: Object,
    required: true
  },
},
  emits: ['complete', 'prevPage', 'update:newPassword'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

onBeforeMount(() => {
  if (props.newPassword.email) {
    email.value = props.newPassword.email;
  }
});

const emit = __emit;
const email = ref<string>();
const password = ref<string>();
const passwordRetype = ref<string>();

const schema = object().shape({
  password:  Yup.string()
    .required( "This field is required")
    .matches(pattern,'FORMS.VALIDATION_ERRORS.PASSWORD_REGEX' ),
  passwordRetype: Yup.string().required("This field is required").oneOf([Yup.ref('password'), null], "Passwords don't match"),
});

const next = () => {
  emit('update:newPassword', {password: password.value});
  emit('complete');
};


const __returned__ = { props, emit, email, password, passwordRetype, schema, next, get Password() { return Password }, get Field() { return Field }, get Form() { return Form } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})